/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
//import { useHistory } from 'react-router-dom';
//react plugin for creating charts
import ChartistGraph from "react-chartist";
//@material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
//@material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import MenuIcon from "@material-ui/icons/Menu";
import Accessibility from "@material-ui/icons/Accessibility";
// import BugReport from "@material-ui/icons/BugReport";
// import Code from "@material-ui/icons/Code";
// import Cloud from "@material-ui/icons/Cloud";
//core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Tasks from "components/Tasks/Tasks.js";
// import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// import { bugs, website, server } from "variables/general.js";
// import Chart from "components/Charts/Chart.js";
import ChartRadar from "components/Charts/ChartRadar.js";
import ChartDoughnut from "components/Charts/ChartDoughnut.js";
import ChartPolar from "components/Charts/ChartPolar.js";
import Horizontal from "components/Charts/Horizontal.js";
import ChartLine from "components/Charts/ChartLine.js";
import ChartBar from "components/Charts/ChartBar";
import TSSelect from "components/Forms/TSSelect";
import TabGroup from "components/Tabs/TabGroup";
import TabGroup2 from "components/Tabs/TabGroup2";
import GaugeChart from "react-gauge-chart";
import { Redirect } from "react-router-dom";
import MapThailand from "components/Map/MapThailand";
import Popup from "reactjs-popup";
import ReactFullScreenElement from "react-fullscreen-element";
import KeyboardEventHandler from "react-keyboard-event-handler";
import axios from "utils/httpClient";
import { authHeader } from "_helpers";
import loading from "assets/img/loading-load.gif";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
  js,
  chartRadar,
  chartDoughnut,
  chartPolar,
  horizontal,
  chartLine
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [month2, setMonth2] = useState("");

  //  function checkTap() {
  //   const a = window.location.search;
  //   const b = new URLSearchParams(a);
  //   if(urlTap === "" || b.size === 0){
  //     return '1'
  //   } else if (urlTap !== ""){
  //     return ''
  //   }
  // }

  const [tap, setTap] = useState(() => {
  const params = new URLSearchParams(window.location.search);
  const urlTap = params.get("option1");
  if (urlTap === "" || params.toString() === "") {
    return "1";
  }
  return "";
  });
  const [oldTap, setOldTap] = useState("");
  const [l2Option, setL2Option] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [l5Option, setL5Option] = useState([]);
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [option5, setOption5] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption1, setOldOption1] = useState("1");
  const [optionYear, setOptionYear] = useState([]);
  const [listReport, setListReport] = useState([]);
  const [listReportOther, setListReportOther] = useState([]);
  const [closeList, setCloseList] = useState(false);
  const [, forceUpdate] = useState();
  const [filter, setFilter] = useState(0);
  const [name, setName] = useState("");
  const [days, setDays] = useState("");
  const [days2, setDays2] = useState("");
  const [objective, setObjective] = useState("");
  const [dataSource, setDataSource] = useState("");
  const [fullScreen, setFullScreen] = useState(false);
  const [fullScreenOther, setFullScreenOther] = useState(false);
  const [fullDataId, setFullDataId] = useState(0);
  const [fullDataId2, setFullDataId2] = useState(0);
  const [fullDataId3, setFullDataId3] = useState(0);
  const [fullIsCheck, setFullIsCheck] = useState(0);
  const [isHorizontal, setIsHorizontal] = useState(false);
  const [isFetch, setIsFetch] = useState(false);
  const [serviceUnit, setServiceUnit] = useState(161);
  const [serviceUnitName, setServiceUnitName] = useState(
    "OR งานผู้ป่วยนอกศัลยกรรมและตรวจรักษาพิเศษ"
  );
  const [exportClipboard, setExportClipboard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  var currentUser = JSON.parse(localStorage.getItem('currentUser'))
  //const history = useHistory();

  // const _dataId = (props.location.state !== undefined && props.location.state !== null) ? props.location.state.dataId : null;
  // const _option1 = (props.location.state !== undefined && props.location.state !== null) ? props.location.state.option1 : null;
  // const _option2 = (props.location.state !== undefined && props.location.state !== null) ? props.location.state.option2 : null;
  // const _option3 = (props.location.state !== undefined && props.location.state !== null) ? props.location.state.option3 : null;
  // const _option4 = (props.location.state !== undefined && props.location.state !== null) ? props.location.state.option4 : null;

  const onExport = e => {
    if (e !== undefined) {
      setExportClipboard(e.dataId);
    }
  };

  const d = new Date();
  const monthNames = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ];

  const optionMonth = [
    { value: 0, label: "ไม่ระบุ" },
    { value: 1, label: "ตุลาคม" },
    { value: 2, label: "พฤศจิกายน" },
    { value: 3, label: "ธันวาคม" },
    { value: 4, label: "มกราคม" },
    { value: 5, label: "กุมภาพันธ์" },
    { value: 6, label: "มีนาคม" },
    { value: 7, label: "เมษายน" },
    { value: 8, label: "พฤษภาคม" },
    { value: 9, label: "มิถุนายน" },
    { value: 10, label: "กรกฎาคม" },
    { value: 11, label: "สิงหาคม" },
    { value: 12, label: "กันยายน" }
  ];

  const optionChart = [
    { value: 0, label: "Full screen" },
    { value: 1, label: "Copy to clipboard" },
    { value: 2, label: "Copy link" }
  ];

  const optionChartIsFetch = [
    { value: 0, label: "Full screen" },
    { value: 107, label: "OPD" },
    { value: 161, label: "OR งานผู้ป่วยนอกศัลยกรรมและตรวจรักษาพิเศษ" },
    { value: 173, label: "Laser ศูนย์เลเซอร์" },
    { value: 67, label: "คลินิกพิเศษนอกเวลา (SMC)" },
    { value: 167, label: "Photobiology (รังสีชีววิทยา)" },
    { value: 152, label: "รับยาเดิม" },
    { value: 9001130, label: "Telemedicine" }
  ];

  const optionFilter = [
    { value: 0, label: "ไม่ระบุ" },
    { value: 1, label: "เดือนสะสม" }
  ];

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const dataId = params.get("dataId");
  const urlTap = params.get("option1");
  const urlOption2 = params.get("option2");
  const urlOption3 = params.get("option3");
  const urlOption4 = params.get("option4");


  // const dataId = _dataId;
  // const urlTap = _option1 != null ? String(_option1) : null;
  // const urlOption2 = _option2
  // const urlOption3 = _option3
  // const urlOption4 = _option4

  const onTap = e => {
    if (urlTap !== "") {
      var url = document.location.href;
      window.history.pushState({}, "", url.split("?")[0]);
    }
    setOldTap(tap);
    setTap(e);
  };

  const onFetch = e => {
    setIsFetch(e);
  };

  function setMonthF(e) {
    setMonth2(e);
  }

  function setChartMenu(e, num) {
    if (
      e.dataId !== "esc" &&
      !fullScreen &&
      e.dataId !== 0 &&
      e.dataId !== undefined
    ) {
      if (num === 1) {
        setFullDataId(e.dataId);
      } else if (num === 2) {
        setFullDataId2(e.dataId);
      } else if (num === 3) {
        setFullDataId3(e.dataId);
      } else if (num === 4) {
        setFullIsCheck(true);
        setFullDataId(e.dataId);
      } else if (e === 1) {
        console.log("Test");
        console.log(exportClipboard);
      }
      setFullScreen(true);
      setName(e.name);
      setDays(e.days);
      setObjective(e.objective);
      setDataSource(e.dataSource);
    } else if (fullScreen && e.dataId !== 0 && fullDataId !== 0) {
      setFullScreen(false);
      setName("");
      setDays("");
      setObjective("");
      setDataSource("");
      setFullDataId(0);
      setFullDataId2(0);
      setFullDataId3(0);
      setFullIsCheck(false);
    } else if (e === "esc") {
      setFullScreen(false);
    }
  }

  function setChartMenu2(e, name) {
    if (e === 0) {
      if (!fullScreen) {
        setFullScreen(true);
      } else {
        setFullScreen(false);
      }
    } else if (e === "esc") {
      setFullScreen(false);
    } else if (e === 1) {
      axios(
        "/api/v1/data/clipboard?data=" +
          (name === undefined ? exportClipboard : name) +
          "&year=" +
          year +
          "&filter=" +
          filter
      )
        .then(response => response.data)
        .then(
          result => {
            console.log(result);
            excelData(result);
          },
          error => {
            console.log(error);
          }
        );
      console.log(exportClipboard);
    } else if (e === 2) {
      var dataId = 0;
      if (tap == 2 || tap == 3) {
        dataId = option3;
      } else if (tap == 3) {
        dataId = option4;
      } else if (tap == 4) {
        dataId = option5;
      }
      var a =
        document.location.href +
        "?dataId=" +
        dataId +
        "&option1=" +
        tap +
        "&option2=" +
        option2 +
        "&option3=" +
        option3 +
        "&option4=" +
        (option4 != "" ? option4 : 0);

      try {
        navigator.clipboard.writeText(a);
        console.log("copy");
      } catch (err) {
        console.log("fail copy");
      }
    } else if ((e !== 0 && e !== 1) || e === 99) {
      setServiceUnit(name.value);
      setServiceUnitName(name.label);
    }
  }

  const excelData = array => {
    var csv = "",
      row,
      cell;
    for (row = 0; row < array.length; row++) {
      for (cell = 0; cell < array[row].length; cell++) {
        csv += (array[row][cell] + "").replace(/[\n\t]+/g, " ");
        if (cell + 1 < array[row].length) csv += "\t";
      }
      if (row + 1 < array.length) csv += "\n";
    }

    try {
      navigator.clipboard.writeText(csv);
      console.log("copy");
    } catch (err) {
      console.log("fail copy");
    }
  };

  function setChartMenuOther(e) {
    if (e !== "esc") {
      setFullScreenOther(true);
      if (e.name !== undefined) {
        setName(e.name);
      }
      if (e.dataId !== undefined) {
        setFullDataId(e.dataId);
      }
      if (e.isHorizontal !== undefined) {
        setIsHorizontal(e.isHorizontal);
      }
      if (fullScreenOther && fullDataId !== 0) {
        setFullScreenOther(false);
        setFullDataId(0);
        if (e.isHorizontal !== undefined) {
          setIsHorizontal(false);
        }
      }
      if (fullScreenOther && e.dataId === undefined && fullDataId === 0) {
        setFullScreenOther(false);
        if (e.isHorizontal !== undefined) {
          setIsHorizontal(false);
        }
      }
    } else if (e === "esc") {
      setFullScreenOther(false);
    }
  }

  const isCheck = () => {
    if (tap !== oldOption1 && urlOption2 === null) {
      return [{ value: "", label: "" }];
    } else if ((tap !== oldOption1 || urlTap === "1") && urlOption2 !== null) {
      if (l2Option.length !== 0) {
        var value = l2Option.filter(p => p.value === Number(urlOption2));
        return [value[0]];
      }
    }
  };

  const isCheck2 = () => {
    if (option2 !== oldOption2 && urlOption3 === null) {
      return [{ value: "", label: "" }];
    } else if (option2 !== oldOption2 && urlOption3 !== null) {
      if (l3Option.length !== 0) {
        var a = 0;
        if (urlOption3 === "0") {
          a = dataId;
        } else {
          a = urlOption3;
        }
        var value = l3Option.filter(p => p.value === Number(a));
        return [value[0]];
      }
    }
  };

  const isCheck3 = () => {
    if (option2 !== oldOption2) {
      return [{ value: "", label: "" }];
    }

    if (option3 !== oldOption3 && urlOption4 === null) {
      return [{ value: "", label: "" }];
    } else if (option3 !== oldOption3 && urlOption4 !== null) {
      if (l4Option.length !== 0) {
        var b = 0;
        if (urlOption4 === "0") {
          b = dataId;
        } else {
          b = urlOption4;
        }
        var value2 = l4Option.filter(p => p.value === Number(b));
        return [value2[0]];
      }
    }
  };

  const isCheck4 = () => {
    if (option3 !== oldOption3) {
      return [{ value: "", label: "" }];
    }
    if (option4 !== oldOption4 && urlOption4 === null) {
      return [{ value: "", label: "" }];
    } else if (option4 !== oldOption4 && urlOption4 !== null) {
      if (l5Option.length !== 0) {
        var value2 = l5Option.filter(p => p.value === Number(dataId));
        return [value2[0]];
      }
    }
  };

  useEffect(() => {
    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          optionYear.push({ value: 0, label: "ไม่ระบุ" });
          result.forEach(e => {
            optionYear.push(e);
          });
        },
        error => {
          console.log(error);
        }
      );

      var js = {
        UserName: currentUser.userName,
      }

      axios.post("/api/v1/data/datacenterLog", js)
      .then (
        result => {
          
        },
        error => { console.log(error);}
      );
    
  }, []);

  useEffect(() => {
    if (urlTap !== null) {
      setTap(urlTap);
    }
    if (urlOption2 !== null) {
      setOption2(urlOption2);
    }
    if (urlOption3 !== null) {
      if (urlOption3 === "0") {
        // if(option3 === "" || option3 === null) {
        //   setOption3(dataId);
        // }
        setOption3(dataId);
        setOption4(0);
      } else {
        setOption3(urlOption3);
      }
    }
    if (urlOption4 !== null) {
      if (urlOption4 === "0") {
        // if(option4 === "" || option4 === null) {
        //   setOption4(dataId);
        // }
        setOption4(dataId);
      } else {
        setOption4(urlOption4);
        if (option5 === "" || option5 === null) {
          setOption5(dataId);
        }
        //setOption5(dataId);
      }
    }
  });

  useEffect(() => {
    if (urlTap !== "1" && urlTap !== "4" && urlTap !== null) {
      axios("/api/v1/group3/" + urlOption2)
        .then(response => response.data)
        .then(
          result => {
            setL3Option(result.data);
            setOldOption2(urlOption2);
          },
          error => {
            console.log(error);
          }
        );
    } else if (urlOption2 !== null) {
      axios("/api/v1/subGroup3/" + urlOption2)
        .then(response => response.data)
        .then(
          result => {
            setL3Option(result.data);
            setOldOption2(urlOption2);
          },
          error => {
            console.log(error);
          }
        );
    }

    // if (urlTap === "1") {

    //     .then(response => response.json())
    //     .then(
    //       result => {
    //         setL4Option(result.data);
    //         setOldOption3(urlOption3);
    //       },
    //       error => {
    //         console.log(error);
    //       }
    //     );
    // } else {

    //     .then(response => response.json())
    //     .then(
    //       result => {
    //         setL4Option(result.data);
    //         setOldOption3(urlOption3);
    //         setCloseList(true);
    //       },
    //       error => {
    //         console.log(error);
    //       }
    //     );
    // }

    // if (urlTap === "4") {

    //     .then(response => response.json())
    //     .then(
    //       result => {
    //         setL5Option(result.data);
    //         setOldOption4(urlOption4);
    //       },
    //       error => {
    //         console.log(error);
    //       }
    //     );
    // }

    if (urlTap !== null) {

      //   .then(response => response.json())
      //   .then(
      //     result2 => {
      //       setL2Option(result2.data);
      //       setOldOption1(urlTap);
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );
      
      axios("/api/v1/group2/" + urlTap)
      .then(
        result2 => {
          var res = result2.data;
          setL2Option(res.data);
          setOldOption1(urlTap);
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, []);

  useEffect(() => {
    if (tap !== "" && urlTap === null) {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setOldOption1(tap);
      //       setL2Option(result.data);
      //       if (tap !== oldOption1) {
      //         setOption2("");
      //         setOption3("");
      //         setOption4("");
      //         setOption5("");
      //         setL3Option([]);
      //         setL4Option([]);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );
      var urlTapTemp;
      if(urlTap === null){
        urlTapTemp = tap;
      } else {
        urlTapTemp = urlTap;
      }
      axios("/api/v1/group2/" + urlTapTemp)
      .then(
        result => {
          var res = result.data;
          setOldOption1(tap);
          setL2Option(res.data);
          if (tap !== oldOption1) {
            setOption2("");
            setOption3("");
            setOption4("");
            setOption5("");
            setL3Option([]);
            setL4Option([]);
          }
        }, 
        error => {
          console.log(error);
        }
      );  

      axios(
        "/api/v1/checkReport?group1=" +
          tap +
          "&group2=" +
          "" +
          "&group3=" +
          "" +
          "&group4=" +
          "" +
          "&isOther=" +
          true,
        {
          method: "GET"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            var list = [];
            if (
              result.data.reportSub !== null &&
              result.data.reportSub.length > 0 &&
              result.data.isOther
            ) {
              result.data.reportSub.forEach(e => {
                list = list.concat(e.dataId);
              });
              setListReportOther(result.data.reportSub);
            } else {
              setListReportOther([]);
            }
          },
          error => {
            console.log(error);
          }
        );

      axios(
        "/api/v1/checkReport?group1=" +
          tap +
          "&group2=" +
          "" +
          "&group3=" +
          "" +
          "&group4=" +
          "",
        {
          method: "GET"
        }
      )
        .then(response => response.data)
        .then(
          result => {
            var list = [];
            if (
              result.data.reportSub !== null &&
              result.data.reportSub.length > 0 &&
              !result.data.isOther
            ) {
              result.data.reportSub.forEach(e => {
                list = list.concat(e.dataId);
              });
              setListReport(result.data.reportSub);
              setCloseList(false);
            } else {
              setListReport([]);
              setCloseList(true);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [tap]);

  useEffect(() => {
    if (tap !== "1" && tap !== "4") {
      if (option2 !== "") {
        setIsLoading(true);

        //   .then(response => response.json())
        //   .then(
        //     result => {
        //       setL3Option(result.data);
        //       setOldOption2(option2);
        //       setOldTap("");
        //       if (option2 !== oldOption2) {
        //         setOption3("");
        //         setOption4("");
        //         setOption5("");
        //         setL4Option([]);
        //       }


        //         "/api/v1/checkReport?group1=" +
        //           tap +
        //           "&group2=" +
        //           option2 +
        //           "&group3=" +
        //           option3 +
        //           "&group4=" +
        //           option4,
        //         {
        //           method: "GET"
        //         }
        //       )
        //         .then(response => response.json())
        //         .then(
        //           result => {
        //             var list = [];
        //             if (
        //               result.data.reportSub !== null &&
        //               result.data.reportSub.length > 0
        //             ) {
        //               result.data.reportSub.forEach(e => {
        //                 list = list.concat(e.dataId);
        //               });
        //               setListReport(result.data.reportSub);
        //               setCloseList(false);
        //             } else {
        //               setListReport([]);
        //               setCloseList(true);
        //             }
        //           },
        //           error => {
        //             console.log(error);
        //           }
        //         );
        //     },
        //     error => {
        //       console.log(error);
        //     }
        //   );

          axios.get("/api/v1/group3/"+ option2)
          .then (
            result => {
            var res = result.data;
            // setL3Option(res.data);
            var res2 = res.data.filter(x => x.isEnabled === true);
            setL3Option(res2);
            setOldOption2(option2);
            setOldTap("");
              if (option2 !== oldOption2) {
                setOption3("");
                setOption4("");
                setOption5("");
                setL4Option([]);

                var params = new URLSearchParams();
                params.append("group1", tap);
                params.append("group2", option2);
                params.append("group3", option3);
                params.append("group4", option4);
                var request = {
                  params: params
                };
                axios.get("/api/v1/checkReport"+ request)
                .then (
                  result => {
                  var res = result.data;
                  var list = [];
                  if (
                    res.data.reportSub !== null &&
                    res.data.reportSub.length > 0
                  ) {
                    res.data.reportSub.forEach(e => {
                      list = list.concat(e.dataId);
                    });
                    setListReport(res.data.reportSub);
                    setCloseList(false);
                  } else {
                    setListReport([]);
                    setCloseList(true);
                  }
                  },
                  error => { console.log(error);}
                );
              }
              setIsLoading(false);
              // history.replace({ state: null });
            },
            error => { console.log(error);}
          );

        var intervalID = window.setInterval(function() {
          var url = document.location.href;
          window.history.pushState({}, "", url.split("?")[0]);
          window.clearInterval(intervalID);
        }, 2000);

      }
    } else {
      if (option2 !== "") {
        axios("/api/v1/subGroup3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setOldOption2(option2);
              setOldTap("");
              if (option2 !== oldOption2) {
                setOption3("");
                setOption4("");
                setOption5("");
                setL4Option([]);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }

    // const fetchData = async () => {

    //     "/api/v1/checkReport?group1=" +
    //     tap +
    //     "&group2=" +
    //     option2 +
    //     "&group3=" +
    //     '' +
    //     "&group4=" +
    //     '' +
    //     "&isOther=" + true,
    //     {
    //       method: "GET"
    //     }
    //   );
    //   const data = await response.json();
    //   var list = [];
    //   if (
    //     data.data.reportSub !== null &&
    //     data.data.reportSub.length > 0  &&
    //     data.data.isOther
    //   ) {
    //     data.data.reportSub.forEach(e => {
    //       list = list.concat(e.dataId);
    //     });
    //     setListReportOther(data.data.reportSub);
    //   } else {
    //     setListReportOther([]);
    //   }
    // }


    //   "/api/v1/checkReport?group1=" +
    //     tap +
    //     "&group2=" +
    //     option2 +
    //     "&group3=" +
    //     '' +
    //     "&group4=" +
    //     '' +
    //     "&isOther=" + true,
    //   {
    //     method: "GET"
    //   }
    // )
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //     var list = [];
    //     if (
    //       result.data.reportSub !== null &&
    //       result.data.reportSub.length > 0 &&
    //       result.data.isOther
    //     ) {
    //       result.data.reportSub.forEach(e => {
    //         list = list.concat(e.dataId);
    //       });
    //       setListReportOther(result.data.reportSub);
    //     } else {
    //       setListReportOther([]);
    //     }
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // );

    // fetchData();
  }, [option2]);

  useEffect(() => {
    setListReportOther([]);
    const fetchData = async () => {
      const response = await axios(
        "/api/v1/checkReport?group1=" +
          tap +
          "&group2=" +
          option2 +
          "&group3=" +
          "" +
          "&group4=" +
          "" +
          "&isOther=" +
          true,
        {
          method: "GET"
        }
      );
      const data = response.data;
      var list = [];
      if (
        data.data.reportSub !== null &&
        data.data.reportSub.length > 0 &&
        data.data.isOther
      ) {
        data.data.reportSub.forEach(e => {
          list = list.concat(e.dataId);
        });
        setListReportOther(data.data.reportSub);
      } else {
        setListReportOther([]);
      }
    };
    fetchData().catch(error => console.error(error));
    axios(
      "/api/v1/checkReport?group1=" +
        tap +
        "&group2=" +
        option2 +
        "&group3=" +
        option3 +
        "&group4=" +
        (urlOption4 !== null ? option4 : ""),
      {
        method: "GET"
      }
    )
      .then(response => response.data)
      .then(
        result => {
          var list = [];
          if (
            result.data.reportSub !== null &&
            result.data.reportSub.length > 0
          ) {
            result.data.reportSub.forEach(e => {
              list.push([e.dataId]);
            });
            setListReport(result.data.reportSub);
            setCloseList(false);
          } else {
            setListReport([]);
            setCloseList(true);
          }
        },
        error => {
          console.log(error);
        }
      );
  }, [option2]);

  useEffect(() => {
    if (tap === "1") {
      if (option3 !== "") {
        axios("/api/v1/group4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setOldOption3(option3);
              setOldTap("");
              if (option3 !== oldOption3) {
                setOption4("");
                setOption5("");
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  tap +
                  "&group2=" +
                  option2 +
                  "&group3=" +
                  option3 +
                  "&group4=" +
                  (urlOption4 !== null ? option4 : ""),
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setListReport(result.data.reportSub);
                      setCloseList(false);
                    } else {
                      setListReport([]);
                      setCloseList(true);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );
            },
            error => {
              console.log(error);
            }
          );
        var intervalID = window.setInterval(function() {
          var url = document.location.href;
          window.history.pushState({}, "", url.split("?")[0]);
          window.clearInterval(intervalID);
        }, 2000);
      }
    } else {
      if (option3 !== "") {
        axios("/api/v1/subGroup4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setOldOption3(option3);
              setCloseList(true);
              setOldTap("");
              if (option3 !== oldOption3) {
                setOption4("");
                setOption5("");
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }


    //   "/api/v1/checkReport?group1=" +
    //     tap +
    //     "&group2=" +
    //     option2 +
    //     "&group3=" +
    //     option3 +
    //     "&group4=" +
    //     '' +
    //     "&isOther=" + true,
    //   {
    //     method: "GET"
    //   }
    // )
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       var list = [];
    //       if (
    //         result.data.reportSub !== null &&
    //         result.data.reportSub.length > 0 &&
    //         result.data.isOther
    //       ) {
    //         result.data.reportSub.forEach(e => {
    //           list = list.concat(e.dataId);
    //         });
    //         setListReportOther(result.data.reportSub);
    //       } else {
    //         setListReportOther([]);
    //       }
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );
  }, [option3]);

  useEffect(() => {
    setListReportOther([]);
    const fetchData = async () => {
      const response = await axios(
        "/api/v1/checkReport?group1=" +
          tap +
          "&group2=" +
          option2 +
          "&group3=" +
          option3 +
          "&group4=" +
          "" +
          "&isOther=" +
          true,
        {
          method: "GET"
        }
      );
      const data = response.data;
      var list = [];
      if (
        data.data.reportSub !== null &&
        data.data.reportSub.length > 0 &&
        data.data.isOther
      ) {
        data.data.reportSub.forEach(e => {
          list = list.concat(e.dataId);
        });
        setListReportOther(data.data.reportSub);
      } else {
        setListReportOther([]);
      }
    };

    fetchData().catch(error => console.error(error));
    axios(
      "/api/v1/checkReport?group1=" +
        tap +
        "&group2=" +
        option2 +
        "&group3=" +
        option3 +
        "&group4=" +
        (urlOption4 !== null ? option4 : ""),
      {
        method: "GET"
      }
    )
      .then(response => response.data)
      .then(
        result => {
          var list = [];
          if (
            result.data.reportSub !== null &&
            result.data.reportSub.length > 0
          ) {
            result.data.reportSub.forEach(e => {
              list.push([e.dataId]);
            });
            setListReport(result.data.reportSub);
            setCloseList(false);
          } else {
            setListReport([]);
            setCloseList(true);
          }
        },
        error => {
          console.log(error);
        }
      );
  }, [option3]);

  useEffect(() => {
    if (tap === "4") {
      if (option3 !== "") {
        axios("/api/v1/Group5/" + option4)
          .then(response => response.data)
          .then(
            result => {
              setL5Option(result.data);
              setOldOption4(option4);
              setOldTap("");
              if (option4 !== oldOption4) {
                setOption5("");
              }

              axios(
                "/api/v1/checkReport?group1=" +
                  tap +
                  "&group2=" +
                  option2 +
                  "&group3=" +
                  option3 +
                  "&group4=" +
                  option4,
                {
                  method: "GET"
                }
              )
                .then(response => response.data)
                .then(
                  result => {
                    var list = [];
                    if (
                      result.data.reportSub !== null &&
                      result.data.reportSub.length > 0 &&
                      urlTap === null
                    ) {
                      result.data.reportSub.forEach(e => {
                        list.push([e.dataId]);
                      });
                      setListReport(result.data.reportSub);
                      setCloseList(false);
                    } else {
                      setListReport([]);
                      setCloseList(true);
                    }
                  },
                  error => {
                    console.log(error);
                  }
                );
            },
            error => {
              console.log(error);
            }
          );
        var intervalID = window.setInterval(function() {
          var url = document.location.href;
          window.history.pushState({}, "", url.split("?")[0]);
          window.clearInterval(intervalID);
        }, 3000);
      }
    } else {
      setCloseList(true);
    }

    axios(
      "/api/v1/checkReport?group1=" +
        tap +
        "&group2=" +
        option2 +
        "&group3=" +
        option3 +
        "&group4=" +
        option4 +
        "&isOther=" +
        true,
      {
        method: "GET"
      }
    )
      .then(response => response.data)
      .then(
        result => {
          var list = [];
          if (
            result.data.reportSub !== null &&
            result.data.reportSub.length > 0 &&
            result.data.isOther
          ) {
            result.data.reportSub.forEach(e => {
              list = list.concat(e.dataId);
            });
            setListReportOther(result.data.reportSub);
          } else {
            setListReportOther([]);
          }
        },
        error => {
          console.log(error);
        }
      );
  }, [option4]);

  useEffect(() => {
    setCloseList(true);
  }, [option5]);

  const getInfo = e => {
    if (e !== -1 && e !== -2) {
      axios("/api/v1/data/info/" + e)
        .then(response => response.data)
        .then(
          result => {
            setName(result.name);
            setDays(result.days);
            setObjective(result.objective);
            setDataSource(result.dataSource);
            if (isFetch) {
              axios("/api/v1/data/infoDaily", { responseType: "text" })
                .then(response => response.data)
                .then(
                  result => {
                    setDays2(result);
                  },
                  error => {
                    console.log(error);
                  }
                );
            }
          },
          error => {
            console.log(error);
          }
        );
    } else {
      if (days2 === "") {
        axios("/api/v1/data/infoDaily", { responseType: "text" })
          .then(response => response.data)
          .then(
            result => {
              setDays2(result);
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AssignmentInd />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes.cardTitle}>
                ตัวชี้วัด <small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TabGroup2 tap={onTap} setTap={urlTap} />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={798}
                    options={l2Option}
                    onChange={e => setOption2(e)}
                    defaulfAdd={isCheck()}
                    disabled={isLoading}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={797}
                    options={l3Option}
                    onChange={e => setOption3(e)}
                    defaulfAdd={isCheck2()}
                    disabled={isLoading}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              {(tap === "1" || tap === "4") && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={796}
                      options={l4Option}
                      onChange={e => setOption4(e)}
                      defaulfAdd={isCheck3()}
                      disabled={isLoading}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {tap === "4" && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={795}
                      options={l5Option}
                      onChange={e => setOption5(e)}
                      defaulfAdd2={isCheck4()}
                      disabled={isLoading}
                    />
                  </GridItem>
                </GridContainer>
              )}
            </CardBody>
            <CardFooter chart>
              {/* <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div> */}
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="rose" stats icon>
              <CardIcon color="rose">
                <Icon>
                  <DateRange />
                </Icon>
              </CardIcon>
              <p className={classes.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes.cardTitle}>
                ปีงบประมาณ <small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    options={optionYear}
                    zIndex={799}
                    onChange={e => setYear(e)}
                    default={optionYear[0]}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              {year !== 0 && year !== "" && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      options={optionFilter}
                      zIndex={798}
                      onChange={e => setFilter(e)}
                      default={optionFilter[0]}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {/* <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    options={optionMonth}
                    zIndex={998}
                    onChange={e => setMonth(e)}
                    default={optionMonth[0]}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}></GridItem>
              </GridContainer> */}
            </CardBody>
            <CardFooter chart>
              {/* <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div> */}
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        {listReport.map((prop, key) => {
          if (
            tap !== null &&
            option2 === "" &&
            option3 === "" &&
            option4 === "" &&
            option5 === ""
          ) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <CardHeader>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={prop.dataId}
                      option3={0}
                      option4={0}
                      option5={0}
                      filter={filter}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด{" "}
                      {isFetch ? days2 : prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (
            option2 !== "" &&
            tap !== "1" &&
            tap !== "4" &&
            !closeList
          ) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {(prop.isFetch ? optionChartIsFetch : optionChart)
                                .slice(0, 10)
                                .map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() =>
                                      prop.isFetch
                                        ? setChartMenu2(key, name)
                                        : key === 0
                                        ? setChartMenu(prop, 1)
                                        : // : setChartMenu(prop, key)
                                          setChartMenu2(key, prop.dataId)
                                    }
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={prop.dataId}
                      option4={0}
                      option5={0}
                      filter={filter}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (
            option3 !== "" &&
            option4 !== "" &&
            tap === "1" &&
            !closeList
          ) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {(prop.isFetch ? optionChartIsFetch : optionChart)
                                .slice(0, 10)
                                .map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() =>
                                      prop.isFetch
                                        ? setChartMenu2(key, name)
                                        : setChartMenu(prop, 1)
                                    }
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={option3}
                      option4={prop.dataId}
                      option5={0}
                      filter={filter}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (
            option3 !== "" &&
            option4 === "" &&
            tap === "1" &&
            !closeList
          ) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {(prop.isFetch ? optionChartIsFetch : optionChart)
                                .slice(0, 10)
                                .map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() =>
                                      prop.isFetch
                                        ? setChartMenu2(key, name)
                                        : setChartMenu(prop, 1)
                                    }
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={option3}
                      option4={prop.dataId}
                      option5={0}
                      filter={filter}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (option4 !== "" && tap === "4" && !closeList) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChart.slice(0, 3).map((name, key) => (
                                <div
                                  className="menu-item"
                                  onMouseEnter={e =>
                                    (e.target.style.backgroundColor =
                                      "rgb(31, 76, 166)")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.backgroundColor = "#ffffff")
                                  }
                                  onClick={() => setChartMenu(prop, 3)}
                                  style={{
                                    width: "150px",
                                    textAlign: "center"
                                  }}
                                >
                                  <div
                                    onMouseEnter={e =>
                                      (e.target.style.color = "#ffffff")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.color = "black")
                                    }
                                  >
                                    {name.label}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={option3}
                      option4={option4}
                      option5={prop.dataId}
                      filter={filter}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (option3 === "" && tap === "1" && !closeList) {
            return (
              <GridItem xs={12} sm={12} md={prop.isFetch ? 12 : 6}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChart.slice(0, 3).map((name, key) => (
                                <div
                                  className="menu-item"
                                  onMouseEnter={e =>
                                    (e.target.style.backgroundColor =
                                      "rgb(31, 76, 166)")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.backgroundColor = "#ffffff")
                                  }
                                  onClick={() => setChartMenu(prop, 4)}
                                  style={{
                                    width: "150px",
                                    textAlign: "center"
                                  }}
                                >
                                  <div
                                    onMouseEnter={e =>
                                      (e.target.style.color = "#ffffff")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.color = "black")
                                    }
                                  >
                                    {name.label}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={prop.dataId}
                      option4={0}
                      option5={0}
                      filter={filter}
                      isCheck={1}
                      name={prop.name}
                      isFetch={prop.isFetch}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + prop.dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {prop.days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          }
        })}
        {fullScreen && fullDataId && (
          <GridItem xs={12} sm={12} md={6}>
            <ReactFullScreenElement
              fullScreen={fullScreen}
              allowScrollbar={true}
            >
              <Card>
                <KeyboardEventHandler
                  handleKeys={["esc"]}
                  onKeyEvent={(key, e) => setChartMenu(key)}
                />
                <CardHeader>
                  <GridContainer>
                    <GridItem xs={11} sm={11} md={11}></GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <Popup
                        trigger={
                          <div className={classes.hStyle}>
                            {" "}
                            <MenuIcon />{" "}
                          </div>
                        }
                        position="bottom"
                        on="hover"
                        closeOnDocumentClick
                        mouseLeaveDelay={300}
                        mouseEnterDelay={0}
                        contentStyle={{ padding: "0px", border: "none" }}
                        arrow={false}
                      >
                        {/* style={{backgroundColor: "#efefef"}} */}
                        <Card>
                          <div className="menu">
                            {optionChart.slice(0, 3).map((name, key) => (
                              <div
                                className="menu-item"
                                onMouseEnter={e =>
                                  (e.target.style.backgroundColor =
                                    "rgb(31, 76, 166)")
                                }
                                onMouseLeave={e =>
                                  (e.target.style.backgroundColor = "#ffffff")
                                }
                                onClick={() => setChartMenu(fullDataId)}
                                style={{ width: "150px", textAlign: "center" }}
                              >
                                <div
                                  onMouseEnter={e =>
                                    (e.target.style.color = "#ffffff")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.color = "black")
                                  }
                                >
                                  {name.label}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Card>
                      </Popup>
                    </GridItem>
                  </GridContainer>
                  <ChartBar
                    location="Massachusetts"
                    legendPosition="bottom"
                    year={year}
                    tap={tap}
                    oldTap={oldTap}
                    month={month}
                    option2={option2}
                    option3={fullDataId}
                    option4={fullDataId2}
                    option5={fullDataId3}
                    filter={filter}
                    name={name}
                    checkFetch={onFetch}
                    exportData={onExport}
                  />
                </CardHeader>
                <CardBody>
                  <h4 className={classes.cardTitle}></h4>
                  <p className={classes.cardCategory}>{objective}</p>
                </CardBody>
                <CardFooter
                  chart
                  style={{ padding: "0.9375rem 20px", margin: "0px" }}
                >
                  <div className={classes.stats}>
                    <p
                      className={classes.cardCategory}
                      style={{ wordBreak: "break-word" }}
                    >
                      {dataSource + ""}
                    </p>
                  </div>
                </CardFooter>
                <CardFooter chart>
                  <div className={classes.stats}>
                    <AccessTime /> อัพเดตข้อมูลล่าสุด {days} ที่แล้ว
                  </div>
                </CardFooter>
              </Card>
            </ReactFullScreenElement>
          </GridItem>
        )}

        {fullScreen && fullDataId && fullIsCheck && (
          <GridItem xs={12} sm={12} md={6}>
            <ReactFullScreenElement
              fullScreen={fullScreen}
              allowScrollbar={true}
            >
              <Card>
                <KeyboardEventHandler
                  handleKeys={["esc"]}
                  onKeyEvent={(key, e) => setChartMenu(key)}
                />
                <CardHeader>
                  <GridContainer>
                    <GridItem xs={11} sm={11} md={11}></GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <Popup
                        trigger={
                          <div className={classes.hStyle}>
                            {" "}
                            <MenuIcon />{" "}
                          </div>
                        }
                        position="bottom"
                        on="hover"
                        closeOnDocumentClick
                        mouseLeaveDelay={300}
                        mouseEnterDelay={0}
                        contentStyle={{ padding: "0px", border: "none" }}
                        arrow={false}
                      >
                        {/* style={{backgroundColor: "#efefef"}} */}
                        <Card>
                          <div className="menu">
                            {optionChart.slice(0, 3).map((name, key) => (
                              <div
                                className="menu-item"
                                onMouseEnter={e =>
                                  (e.target.style.backgroundColor =
                                    "rgb(31, 76, 166)")
                                }
                                onMouseLeave={e =>
                                  (e.target.style.backgroundColor = "#ffffff")
                                }
                                onClick={() => setChartMenu(fullDataId)}
                                style={{ width: "150px", textAlign: "center" }}
                              >
                                <div
                                  onMouseEnter={e =>
                                    (e.target.style.color = "#ffffff")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.color = "black")
                                  }
                                >
                                  {name.label}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Card>
                      </Popup>
                    </GridItem>
                  </GridContainer>
                  <ChartBar
                    location="Massachusetts"
                    legendPosition="bottom"
                    year={year}
                    tap={tap}
                    oldTap={oldTap}
                    month={month}
                    option2={option2}
                    option3={fullDataId}
                    option4={0}
                    option5={0}
                    filter={filter}
                    isCheck={1}
                    name={name}
                    checkFetch={onFetch}
                    exportData={onExport}
                  />
                </CardHeader>
                <CardBody>
                  <h4 className={classes.cardTitle}></h4>
                  <p className={classes.cardCategory}>{objective}</p>
                </CardBody>
                <CardFooter
                  chart
                  style={{ padding: "0.9375rem 20px", margin: "0px" }}
                >
                  <div className={classes.stats}>
                    <p
                      className={classes.cardCategory}
                      style={{ wordBreak: "break-word" }}
                    >
                      {dataSource + ""}
                    </p>
                  </div>
                </CardFooter>
                <CardFooter chart>
                  <div className={classes.stats}>
                    <AccessTime /> อัพเดตข้อมูลล่าสุด {days} ที่แล้ว
                  </div>
                </CardFooter>
              </Card>
            </ReactFullScreenElement>
          </GridItem>
        )}
      </GridContainer>
      <GridContainer>
        {((option3 !== "" && tap !== "1" && tap !== "4") ||
          (option4 !== "" && tap === "1") ||
          (option5 !== "" && tap === "4")) &&
          !isFetch && (
            <GridItem xs={12} sm={12} md={6}>
              <ReactFullScreenElement
                fullScreen={fullScreen}
                allowScrollbar={true}
              >
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu2(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChart.slice(0, 3).map((name, key) => (
                                <div
                                  className="menu-item"
                                  onMouseEnter={e =>
                                    (e.target.style.backgroundColor =
                                      "rgb(31, 76, 166)")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.backgroundColor = "#ffffff")
                                  }
                                  onClick={() => setChartMenu2(key)}
                                  style={{
                                    width: "150px",
                                    textAlign: "center"
                                  }}
                                >
                                  <div
                                    onMouseEnter={e =>
                                      (e.target.style.color = "#ffffff")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.color = "black")
                                    }
                                  >
                                    {name.label}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      chartData={js.chartData}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={option3}
                      option4={option4}
                      option5={option5}
                      filter={filter}
                      checkFetch={onFetch}
                      serviceUnitFilter={serviceUnit}
                      exportData={onExport}
                      info={getInfo(
                        option3 !== "" && tap !== "1" && tap !== "4"
                          ? option3
                          : option4 !== "" && tap === "1"
                          ? option4
                          : option5 !== "" && tap === "4"
                          ? option5
                          : 0
                      )}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </ReactFullScreenElement>
            </GridItem>
          )}

        {((option3 !== "" && tap !== "1" && tap !== "4") ||
          (option4 !== "" && tap === "1") ||
          (option5 !== "" && tap === "4")) &&
          isFetch && (
            <GridItem xs={12} sm={12} md={12}>
              <ReactFullScreenElement
                fullScreen={fullScreen}
                allowScrollbar={true}
              >
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenu2(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChartIsFetch
                                .slice(0, 10)
                                .map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() =>
                                      setChartMenu2(
                                        optionChartIsFetch.length < 5
                                          ? key
                                          : 99,
                                        name
                                      )
                                    }
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      chartData={js.chartData}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      tap={tap}
                      oldTap={oldTap}
                      month={month}
                      option2={option2}
                      option3={option3}
                      option4={option4}
                      option5={option5}
                      filter={filter}
                      checkFetch={onFetch}
                      exportData={onExport}
                      serviceUnitFilter={serviceUnit}
                      serviceUnitName={serviceUnitName}
                      info={getInfo(
                        option3 !== "" && tap !== "1" && tap !== "4"
                          ? option3
                          : option4 !== "" && tap === "1"
                          ? option4
                          : option5 !== "" && tap === "4"
                          ? option5
                          : 0
                      )}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{objective}</p>
                  </CardBody>
                  <CardFooter
                    chart
                    style={{ padding: "0.9375rem 20px", margin: "0px" }}
                  >
                    <div className={classes.stats}>
                      <p
                        className={classes.cardCategory}
                        style={{ wordBreak: "break-word" }}
                      >
                        {" " + dataSource}
                      </p>
                    </div>
                  </CardFooter>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {isFetch ? days2 : days}{" "}
                      ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </ReactFullScreenElement>
            </GridItem>
          )}

        {/* <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader>
              <ChartRadar
                chartData={chartRadar.chartData}
                location="Massachusetts"
                legendPosition="bottom"
                year={year}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
      </GridContainer>
      <GridContainer>
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  total={true}
                  info={getInfo(-1)}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                  จำนวนครั้งในการใช้บริการในแต่ละวัน
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )} */}
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  totalGender={true}
                  info={getInfo(-1)}
                  name={"จำนวนครั้งในใช้บริการในแต่ละวันแบ่งตามเพศ"}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                  จำนวนครั้งในใช้บริการในแต่ละวันแบ่งตามเพศ
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )} */}
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  serviceUnit={true}
                  info={getInfo(-1)}
                  name={"จำนวนครั้งในการใช้บริการในวันนี้แบ่งตามหน่วยบริการ"}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                  จำนวนครั้งในการใช้บริการในวันนี้แบ่งตามหน่วยบริการ
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )} */}
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  ageRange={true}
                  info={getInfo(-1)}
                  name={"ช่วงอายุของผู้ใช้บริการในวันนี้"}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                ช่วงอายุของผู้ใช้บริการในวันนี้
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )} */}
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  topTen={true}
                  info={getInfo(-1)}
                  name={"โรค Top 10 ประจำเดือน"}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                โรค Top 10 ประจำเดือน {monthNames[d.getMonth()]}
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )} */}
        {/* { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <Horizontal
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  topTen={true}
                  info={getInfo(-1)}
                  name={"โรค Top 10 ประจำเดือน"}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                โรค Top 10 ประจำเดือน {monthNames[d.getMonth()]}
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )}

        { 1 === 1 &&(
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <ChartBar
                  chartData={js.chartData}
                  location="Massachusetts"
                  legendPosition="bottom"
                  year={year}
                  other={true}
                  info={getInfo(-1)}
                  name={"รายงาน"}
                  filter={filter}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}></h4>
                <p className={classes.cardCategory}>
                  รายงาน
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent {days2} ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        )}     */}

        {/* <div style={{ paddingTop: "10px" }}></div>
        <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader>
          <div style={{ fontSize: "25px" , textAlign: "center", fontWeight: "bold"
          , marginTop: "10px", color: "dimgray"}}>
            จำนวนครั้งในการใช้บริการประจำเดือน{monthNames[d.getMonth()]} แบ่งตามจังหวัด
          </div> 
          </CardHeader>
          <CardBody>
            <MapThailand/>
            <div style={{ color: "darkgray", fontSize: "15px"}}>
            จำนวนครั้งในการใช้บริการประจำเดือน{monthNames[d.getMonth()]} แบ่งตามจังหวัด
          </div> 
          </CardBody>
          <CardFooter chart>
            <div className={classes.stats}>
              <AccessTime /> campaign sent {days2} ago
            </div>
          </CardFooter>
        </Card>
        </GridItem> */}
      </GridContainer>
      <GridContainer>
        {listReportOther.map((prop, key) => {
          if (prop.dataId === 4) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader>
                    <ChartBar
                      chartData={js.chartData}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      total={true}
                      info={getInfo(-1)}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>
                      จำนวนครั้งในการใช้บริการในแต่ละวัน
                    </p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (prop.dataId === 5) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <ReactFullScreenElement
                  fullScreen={fullScreenOther}
                  allowScrollbar={true}
                >
                  <Card>
                    <KeyboardEventHandler
                      handleKeys={["esc"]}
                      onKeyEvent={(key, e) => setChartMenuOther(key)}
                    />
                    <CardHeader>
                      <GridContainer>
                        <GridItem xs={11} sm={11} md={11}></GridItem>
                        <GridItem xs={1} sm={1} md={1}>
                          <Popup
                            trigger={
                              <div className={classes.hStyle}>
                                {" "}
                                <MenuIcon />{" "}
                              </div>
                            }
                            position="bottom"
                            on="hover"
                            closeOnDocumentClick
                            mouseLeaveDelay={300}
                            mouseEnterDelay={0}
                            contentStyle={{ padding: "0px", border: "none" }}
                            arrow={false}
                          >
                            {/* style={{backgroundColor: "#efefef"}} */}
                            <Card>
                              <div className="menu">
                                {optionChart.slice(0, 3).map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() => setChartMenuOther(prop)}
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Card>
                          </Popup>
                        </GridItem>
                      </GridContainer>
                      <ChartBar
                        chartData={js.chartData}
                        location="Massachusetts"
                        legendPosition="bottom"
                        year={year}
                        totalGender={true}
                        info={getInfo(-1)}
                        name={"จำนวนครั้งในการใช้บริการในแต่ละวันแบ่งตามเพศ"}
                        data={fullDataId}
                      />
                    </CardHeader>
                    <CardBody>
                      <h4 className={classes.cardTitle}></h4>
                      <p className={classes.cardCategory}>
                        จำนวนครั้งในการใช้บริการในแต่ละวันแบ่งตามเพศ
                      </p>
                    </CardBody>
                    <CardFooter chart>
                      <div className={classes.stats}>
                        <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                      </div>
                    </CardFooter>
                  </Card>
                </ReactFullScreenElement>
              </GridItem>
            );
          } else if (prop.dataId === 6) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader>
                    <ChartBar
                      chartData={js.chartData}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      serviceUnit={true}
                      info={getInfo(-1)}
                      name={
                        "จำนวนครั้งในการใช้บริการในวันนี้แบ่งตามหน่วยบริการ"
                      }
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>
                      จำนวนครั้งในการใช้บริการในวันนี้แบ่งตามหน่วยบริการ
                    </p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (prop.dataId === 8) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <ReactFullScreenElement
                  fullScreen={fullScreenOther}
                  allowScrollbar={true}
                >
                  <Card>
                    <KeyboardEventHandler
                      handleKeys={["esc"]}
                      onKeyEvent={(key, e) => setChartMenuOther(key)}
                    />
                    <CardHeader>
                      <GridContainer>
                        <GridItem xs={11} sm={11} md={11}></GridItem>
                        <GridItem xs={1} sm={1} md={1}>
                          <Popup
                            trigger={
                              <div className={classes.hStyle}>
                                {" "}
                                <MenuIcon />{" "}
                              </div>
                            }
                            position="bottom"
                            on="hover"
                            closeOnDocumentClick
                            mouseLeaveDelay={300}
                            mouseEnterDelay={0}
                            contentStyle={{ padding: "0px", border: "none" }}
                            arrow={false}
                          >
                            {/* style={{backgroundColor: "#efefef"}} */}
                            <Card>
                              <div className="menu">
                                {optionChart.slice(0, 3).map((name, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() => setChartMenuOther(prop)}
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {name.label}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Card>
                          </Popup>
                        </GridItem>
                      </GridContainer>
                      <ChartBar
                        chartData={js.chartData}
                        location="Massachusetts"
                        legendPosition="bottom"
                        year={year}
                        ageRange={true}
                        info={getInfo(-1)}
                        name={"ช่วงอายุของผู้ใช้บริการในวันนี้"}
                        checkFetch={onFetch}
                        data={fullDataId}
                        exportData={onExport}
                      />
                    </CardHeader>
                    <CardBody>
                      <h4 className={classes.cardTitle}></h4>
                      <p className={classes.cardCategory}>
                        ช่วงอายุของผู้ใช้บริการในวันนี้
                      </p>
                    </CardBody>
                    <CardFooter chart>
                      <div className={classes.stats}>
                        <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                      </div>
                    </CardFooter>
                  </Card>
                </ReactFullScreenElement>
              </GridItem>
            );
          } else if (!prop.isFetch && !prop.isHorizontal) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenuOther(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChart.slice(0, 3).map((name, key) => (
                                <div
                                  className="menu-item"
                                  onMouseEnter={e =>
                                    (e.target.style.backgroundColor =
                                      "rgb(31, 76, 166)")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.backgroundColor = "#ffffff")
                                  }
                                  onClick={() => setChartMenuOther(prop, 1)}
                                  style={{
                                    width: "150px",
                                    textAlign: "center"
                                  }}
                                >
                                  <div
                                    onMouseEnter={e =>
                                      (e.target.style.color = "#ffffff")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.color = "black")
                                    }
                                  >
                                    {name.label}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <ChartBar
                      //chartData={js.chartData}
                      other={true}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      info={getInfo(-2)}
                      name={prop.name}
                      filter={filter}
                      data={prop.dataId}
                      exportData={onExport}
                      checkFetch={onFetch}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.name}</p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (!prop.isFetch && prop.isHorizontal) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <KeyboardEventHandler
                    handleKeys={["esc"]}
                    onKeyEvent={(key, e) => setChartMenuOther(key)}
                  />
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionChart.slice(0, 3).map((name, key) => (
                                <div
                                  className="menu-item"
                                  onMouseEnter={e =>
                                    (e.target.style.backgroundColor =
                                      "rgb(31, 76, 166)")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.backgroundColor = "#ffffff")
                                  }
                                  onClick={() => setChartMenuOther(prop, 1)}
                                  style={{
                                    width: "150px",
                                    textAlign: "center"
                                  }}
                                >
                                  <div
                                    onMouseEnter={e =>
                                      (e.target.style.color = "#ffffff")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.color = "black")
                                    }
                                  >
                                    {name.label}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <Horizontal
                      //chartData={js.chartData}
                      other={true}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      name={prop.name}
                      info={getInfo(-2)}
                      data={prop.dataId}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>{prop.name}</p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (prop.dataId === 2) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader>
                    <GridContainer>
                      <GridItem xs={11} sm={11} md={11}></GridItem>
                      <GridItem xs={1} sm={1} md={1}>
                        <Popup
                          trigger={
                            <div className={classes.hStyle}>
                              {" "}
                              <MenuIcon />{" "}
                            </div>
                          }
                          position="bottom"
                          on="hover"
                          closeOnDocumentClick
                          mouseLeaveDelay={300}
                          mouseEnterDelay={0}
                          contentStyle={{ padding: "0px", border: "none" }}
                          arrow={false}
                        >
                          {/* style={{backgroundColor: "#efefef"}} */}
                          <Card>
                            <div className="menu">
                              {optionMonth
                                .slice(0, 13)
                                .map((monthName, key) => (
                                  <div
                                    className="menu-item"
                                    onMouseEnter={e =>
                                      (e.target.style.backgroundColor =
                                        "rgb(31, 76, 166)")
                                    }
                                    onMouseLeave={e =>
                                      (e.target.style.backgroundColor =
                                        "#ffffff")
                                    }
                                    onClick={() => setMonthF(key)}
                                    style={{
                                      width: "150px",
                                      textAlign: "center"
                                    }}
                                  >
                                    <div
                                      onMouseEnter={e =>
                                        (e.target.style.color = "#ffffff")
                                      }
                                      onMouseLeave={e =>
                                        (e.target.style.color = "black")
                                      }
                                    >
                                      {monthName.label}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </Card>
                        </Popup>
                      </GridItem>
                    </GridContainer>
                    <Horizontal
                      chartData={js.chartData}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      month={month2}
                      topTen={true}
                      info={getInfo(-1)}
                      name={"โรค Top 10 ประจำปีงบประมาณ"}
                    />
                    <div className={classes.stats}></div>
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}></h4>
                    <p className={classes.cardCategory}>
                      โรค Top 10 ประจำเดือน {monthNames[d.getMonth()]}
                    </p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          } else if (prop.dataId === 3) {
            return (
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader>
                    <div
                      style={{
                        fontSize: "25px",
                        textAlign: "center",
                        fontWeight: "bold",
                        marginTop: "10px",
                        color: "dimgray"
                      }}
                    >
                      จำนวนครั้งในการใช้บริการประจำเดือน
                      {monthNames[d.getMonth()]} แบ่งตามจังหวัด
                    </div>
                  </CardHeader>
                  <CardBody>
                    <MapThailand />
                    <div style={{ color: "darkgray", fontSize: "15px" }}>
                      จำนวนครั้งในการใช้บริการประจำเดือน
                      {monthNames[d.getMonth()]} แบ่งตามจังหวัด
                    </div>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            );
          }
        })}
        {fullScreenOther && fullDataId && (
          <GridItem xs={12} sm={12} md={12}>
            <ReactFullScreenElement
              fullScreen={fullScreenOther}
              allowScrollbar={true}
            >
              <Card>
                <KeyboardEventHandler
                  handleKeys={["esc"]}
                  onKeyEvent={(key, e) => setChartMenuOther(key)}
                />
                <CardHeader>
                  <GridContainer>
                    <GridItem xs={11} sm={11} md={11}></GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <Popup
                        trigger={
                          <div className={classes.hStyle}>
                            {" "}
                            <MenuIcon />{" "}
                          </div>
                        }
                        position="bottom"
                        on="hover"
                        closeOnDocumentClick
                        mouseLeaveDelay={300}
                        mouseEnterDelay={0}
                        contentStyle={{ padding: "0px", border: "none" }}
                        arrow={false}
                      >
                        {/* style={{backgroundColor: "#efefef"}} */}
                        <Card>
                          <div className="menu">
                            {optionChart.slice(0, 3).map((name, key) => (
                              <div
                                className="menu-item"
                                onMouseEnter={e =>
                                  (e.target.style.backgroundColor =
                                    "rgb(31, 76, 166)")
                                }
                                onMouseLeave={e =>
                                  (e.target.style.backgroundColor = "#ffffff")
                                }
                                onClick={() => setChartMenuOther(fullDataId)}
                                style={{ width: "150px", textAlign: "center" }}
                              >
                                <div
                                  onMouseEnter={e =>
                                    (e.target.style.color = "#ffffff")
                                  }
                                  onMouseLeave={e =>
                                    (e.target.style.color = "black")
                                  }
                                >
                                  {name.label}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Card>
                      </Popup>
                    </GridItem>
                  </GridContainer>
                  {isHorizontal && (
                    <Horizontal
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      other={true}
                      info={getInfo(-2)}
                      name={name}
                      filter={filter}
                      data={fullDataId}
                    />
                  )}
                  {!isHorizontal && (
                    <ChartBar
                      //chartData={js.chartData}
                      other={true}
                      location="Massachusetts"
                      legendPosition="bottom"
                      year={year}
                      info={getInfo(-2)}
                      name={name}
                      filter={filter}
                      data={fullDataId}
                      checkFetch={onFetch}
                      exportData={onExport}
                    />
                  )}
                </CardHeader>
                <CardBody>
                  <h4 className={classes.cardTitle}></h4>
                  <p className={classes.cardCategory}>{name}</p>
                </CardBody>
                <CardFooter chart>
                  <div className={classes.stats}>
                    <AccessTime /> อัพเดตข้อมูลล่าสุด {days2} ที่แล้ว
                  </div>
                </CardFooter>
              </Card>
            </ReactFullScreenElement>
          </GridItem>
        )}
      </GridContainer>
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader>
              <ChartDoughnut
                chartData={chartDoughnut.chartData}
                location="Massachusetts"
                legendPosition="bottom"
              />
            </CardHeader>
            <CardBody></CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader>
              <ChartPolar
                chartData={chartPolar.chartData}
                location="Massachusetts"
                legendPosition="bottom"
              />
            </CardHeader>
            <CardBody></CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader>
              <Horizontal
                chartData={horizontal.chartData}
                location="Massachusetts"
                legendPosition="bottom"
              />
            </CardHeader>
            <CardBody></CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader></CardHeader>
            <ChartLine
              chartData={chartLine.chartData}
              location="Massachusetts"
              legendPosition="bottom"
            />
            <CardBody></CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Used Space</p>
              <h3 className={classes.cardTitle}>
                49/50 <small>GB</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  Get more space
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Revenue</p>
              <h3 className={classes.cardTitle}>$34,245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Last 24 Hours
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>info_outline</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Fixed Issues</p>
              <h3 className={classes.cardTitle}>75</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />
                Tracked from Github
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Followers</p>
              <h3 className={classes.cardTitle}>+245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Just Updated
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Sales</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                increase in today sales.
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Email Subscriptions</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader>
              <GaugeChart
                id="gauge-chart4"
                nrOfLevels={10}
                cornerRadius={1}
                percent={0.6}
                arcWidth={0.2}
                textColor={"000000"}
                arcPadding={0.02}
              />
            </CardHeader>
            <CardBody></CardBody>
            <CardFooter chart></CardFooter>
          </Card>
        </GridItem>
      </GridContainer> */}
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Bugs",
                tabIcon: BugReport,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0, 3]}
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={bugs}
                  />
                )
              },
              {
                tabName: "Website",
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0]}
                    tasksIndexes={[0, 1]}
                    tasks={website}
                  />
                )
              },
              {
                tabName: "Server",
                tabIcon: Cloud,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={server}
                  />
                )
              }
            ]}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["ID", "Name", "Salary", "Country"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands"],
                  ["4", "Philip Chaney", "$38,735", "Korea, South"]
                ]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer> */}
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <Chart
                chartData={js.chartData}
                location="Massachusetts"
                legendPosition="bottom"
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer> */}
    </div>
  );
}
